module.exports = __webpack_public_path__ + "img/desc_bottom_fk4151.1cd38be5.png";